import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://rawajsmart.com";
const SITE_NAME = "رواج الذكية Rawaj Smart | منصة التسويق للمنشآت";

export default function Seo({ title, description, keywords, image, path = "", type = "website", jsonLd }) {
  const fullTitle = title ? `${title} | رواج الذكية Rawaj Smart` : SITE_NAME;
  const url = `${SITE_URL}${path}`;
  const img = image || `${SITE_URL}/rawaj-hero.jpg`;
  React.useEffect(() => {  // أزل عنوان/وصف index.html الثابتين حتى لا يقرأ الزاحف وسمين مكررين
    document.querySelectorAll("head [data-static-seo]").forEach((e) => e.remove());
  }, []);
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="رواج الذكية" />
      <meta property="og:locale" content="ar_SA" />
      {["ar_AE", "ar_KW", "ar_QA", "ar_BH", "ar_OM", "ar_EG", "ar_JO"].map((l) => <meta key={l} property="og:locale:alternate" content={l} />)}
      <link rel="alternate" hrefLang="ar" href={url} />
      <link rel="alternate" hrefLang="ar-SA" href={url} />
      <link rel="alternate" hrefLang="ar-AE" href={url} />
      <link rel="alternate" hrefLang="ar-KW" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />
      <meta name="geo.region" content="SA" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {jsonLd && [].concat(jsonLd).map((j, i) => <script key={i} type="application/ld+json">{JSON.stringify(j)}</script>)}
    </Helmet>
  );
}
